<ul>
  @for (actionPoint of actionPoints(); track actionPoint.id) {
    <li class="mt-2">
      <button
        class="btn-white-stroked w-full flex justify-between p-3"
        (click)="sendAction(actionPoint)"
        [disabled]="!twoWayCommunication()"
      >
        <div class="flex flex-col text-left">
          <span
            class="text-sm font-semibold"
            [ngClass]="!twoWayCommunication() ? 'text-ui-gray-750' : 'text-ui-dark'"
          >{{ actionPoint.friendlyName || actionPoint.name }}</span>
          @if (actionPoint.dcUid) {
            <span
              class="text-xs font-semibold"
              [ngClass]="!twoWayCommunication() ? 'text-ui-gray-750' : 'text-ui-dark'"
            >{{ actionPoint.deviceName }}</span>
          }
        </div>
      </button>
    </li>
  } @empty {
    <avs-no-data-placeholder noDataText="No actions yet" />
  }
</ul>
